import { useMutation, useQuery } from "@apollo/client";

import { graphql } from "@/__generated__";
import ContentLoader, { contentLoaded } from "@/components/shared/ContentLoader";
import UserProfile from "@/components/UserProfile";

const QUserProfilePage = graphql(`
  query QUserProfilePage {
    currentUser {
      ...UserProfile_User
    }
  }
`);

const MUserProfilePage_UpdateProfile = graphql(`
  mutation MUserProfilePage_UpdateProfile($input: UsersUpdateProfileInput!) {
    usersUpdateProfile(input: $input) {
      userErrors {
        ... on ArgumentError {
          message
          argument
        }
      }
    }
  }
`);

export default function UserProfilePage() {
  const { data, called, loading } = useQuery(QUserProfilePage);

  const updateProfileMutation = useMutation(MUserProfilePage_UpdateProfile, {
    refetchQueries: ["QUserProfilePage"],
  });

  const user = data?.currentUser;

  if (!contentLoaded(called, loading, user)) return <ContentLoader />;

  return <UserProfile updateProfileMutation={updateProfileMutation} user={user} />;
}
